import api from "lib/api";
import apiFormData from "lib/apiFormData";

const GET_COMMON_TYPE_LINK = "/v1/dropdown/getCommonTypeByGroupType";

export const getEmployeeList = async (params = {}) => {
  return await api.post("/v1/employee/getEmployeePaging", params);
};

export const createEmployee = async (params = {}) => {
  return await apiFormData.post("/v1/employee/createEmployee", params);
};

export const getWorkflowByRequestId = async (params) => {
  return await api.post("/v1/leaveRequest/getWorkflowByRequestId", params);
};

export const getWorkingCondition = async (params = {}) => {
  return await api.post("/v1/workingCondition/getWorkingCondition", params);
};

export const getEmployee = async (params = {}) => {
  return await api.post("/v1/employee/findAllEmployee", params);
};

export const getDropDown = async (params = {}) => {
  return await api.post("/v1/dropdown/getEmployee", params);
};

export const getGeneralInfomation = async (params = {}) => {
  return await api.post("/v1/employee/getGeneralInformation", params);
};
export const getContactInformation = async (params = {}) => {
  return await api.post("/v1/employee/getContactInformation", params);
};

export const getFilesExpense = async (params = {}) => {
  return await api.post("v1/expense/files", params);
};

export const getFamilyInformation = async (params = {}) => {
  return await api.post("/v1/employee/getFamilyInformation", params);
};

export const getWorkExperienceInformation = async (params = {}) => {
  return await api.post("/v1/employee/getWorkExperienceInformation", params);
};

export const getEducationInformation = async (params = {}) => {
  return await api.post("/v1/employee/getEducationInformation", params);
};

export const getEmploymentInformation = async (params = {}) => {
  return await api.post("/v1/employee/getEmploymentInformation", params);
};

export const updateGeneralInformation = async (params = {}) => {
  return await apiFormData.post(
    "/v1/employee/updateGeneralInformation",
    params
  );
};

export const getOvertimeRequestByIdRequest = async (params) => {
  return await api.post("/v1/overtimeRequest/getOvertimeRequest", params);
};

export const getCollectTimeRequestByIdRequest = async (params) => {
  return await api.post("/v1/collectTimeRequest/getCollectTimeRequest", params);
};

export const getOvertimeCondition = async (params = {}) => {
  return await api.post("/v1/overtimeCondition/getOvertimeCondition", params);
};


export const getLeaveRequestByIdRequest = async (params) => {
  return await api.post("/v1/leaveRequest/getLeaveRequest", params);
};

export const getDocumentRequestByIdRequest = async (params) => {
  return await api.post("/v1/documentRequest/getDocumentRequest", params);
};

export const getEndorseTimeRequestByIdRequest = async (params) => {
  return await api.post(
    "/v1/EndorseTimeRequest/getEndorseTimeRequest",
    params
  );
};

export const getOffsiteWorkRequestByIdRequest = async (params) => {
  return await api.post("/v1/offsiteWorkRequest/getOffsiteWorkRequest", params);
};

export const getRedeemTimeRequestByIdRequest = async (params) => {
  return await api.post("/v1/redeemTimeRequest/getRedeemTimeRequest", params);
};

export const updateContactInformation = async (params = {}) => {
  return await api.post("/v1/employee/updateContactInformation", params);
};

export const updateContactInfoProfile = async (params = {}) => {
  return await api.post("v1/employee/updateProFileInformation", params);
};

export const updateImageInformationProfile = async (params = {}) => {
  return await apiFormData.post("v1/employee/updateImageInformation", params);
};

export const updateEmploymentInformation = async (params = {}) => {
  return await api.post("/v1/employee/updateEmploymentInformation", params);
};

export const updateEmploymentInformationWithMovement = async (params = {}) => {
  return await api.post("/v1/employee/updateEmploymentInformationWithMovement", params);
};

export const updateEducationInformation = async (params = {}) => {
  return await api.post("/v1/employee/updateEducationInformation", params);
};

export const updateFamilyInformation = async (params = {}) => {
  return await api.post("/v1/employee/updateFamilyInformation", params);
};

export const updateWorkExperienceInformation = async (params = {}) => {
  return await api.post("/v1/employee/updateWorkExperienceInformation", params);
};

export const getTimeplanShiftPaging = async (params = {}) => {
  return await api.post("/v1/timePlanShift/getTimeplanShiftPaging", params);
};

export const getTimeplanShift = async (params = {}) => {
  return await api.post("/v1/timePlanShift/getTimeplanShift", params);
};

export const createTimePlanShift = async (params = {}) => {
  return await api.post("/v1/timePlanShift/createTimeplanShift", params);
};

export const updateTimeplanShift = async (params = {}) => {
  return await api.post("/v1/timePlanShift/updateTimeplanShift", params);
};
export const updateTimePlanShiftAll = async (params = {}) => {
  return await api.post("/v1/timePlanShift/updateTimeplanShiftAll", params);
};

export const manageTimeplanShiftStatus = async (params = {}) => {
  return await api.post("/v1/timePlanShift/manageTimeplanShiftStatus", params);
};

export const getWorkScheduleCalendar = async (params = {}) => {
  return await api.post("/v1/workSchedule/getWorkScheduleCalendar", params);
};

export const getEmployeeLeaveBenefitListPaging = async (params = {}) => {
  return await api.post("/v1/leaveBenefit/getLeaveBenefitPaging", params);
};

export const getLeaveGroupIsLeave = async (params = {}) => {
  return await api.post("/v1/dropdown/getLeaveCategoryGroupIsLeave", params);
};

export const getEmployeeLeaveBenefit = async (params = {}) => {
  return await api.post("/v1/leaveBenefit/getLeaveBenefitDetails", params);
};

export const createEmployeeLeaveBenefit = async (params = {}) => {
  return await api.post("/v1/leaveBenefit/createCustomLeaveBenefit", params);
};

export const getSubOrdinates = async (params = {}) => {
  return await api.post("/v1/supervisorManagement/getSubOrdinates", params);
};

export const getSubOrdinatesPaging = async (params = {}) => {
  return await api.post("/v1/supervisorManagement/getSubOrdinatesPaging", params);
};

export const getSupervisor = async (params = {}) => {
  return await api.post("/v1/supervisorManagement/getSupervisor", params);
};

export const getOrganizationStructure = async (params = {}) => {
  return await api.post("/v1/organization/getOrganizationStructure", params);
};

export const cancelCustomLeave = async (params = {}) => {
  return await api.post("/v1/leaveBenefit/cancelCustomLeaveBenefit", params);
};
export const getDepartmentOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getStmDepartment", params);
};

export const getPositionOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getPosition", params);
};

export const getShiftOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getShiftsByCompannyId", params);
};

export const getWorkInLocationOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getWorkInLocationByCompannyId", params);
};

export const getHolidayCalendarOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getHolidayCalendarByCompannyId", params);
};

export const getAttendanceShiftsList = async (params = {}) => {
  return await api.post("/v1/attendance/shifts/getAttendanceShiftsList", params);
};

export const deleteTimePlanShift = async (params = {}) => {
  return await api.post("/v1/timePlanShift/deleteTimeplanShift", params);
};

export const createWorkInLocation = async (params = {}) => {
  return await api.post("/v1/employee/createWorkInLocation", params);
};

export const deleteWorkInLocation = async (params = {}) => {
  return await api.post("/v1/employee/deleteWorkInLocation", params);
};

export const getWorkInLocation = async (params = {}) => {
  return await api.post("/v1/employee/getWorkInLocation", params);
};

export const deleteFamilyInformation = async (params = {}) => {
  return await api.post("/v1/employee/deleteFamilyInformation", params);
};

export const deleteWorkExperienceInformation = async (params = {}) => {
  return await api.post("/v1/employee/deleteWorkExperienceInformation", params);
};

export const getWorkInLocationInEmployee = async (params = {}) => {
  return await api.post("/v1/dropdown/getWorkInLocationInEmployee", params);
};

export const getCommonTypeCompany = async (params = {}) => {
  return await api.post("/v1/dropdown/getCommonTypeCompany", params);
};

export const deleteEducationInformation = async (params = {}) => {
  return await api.post("/v1/employee/deleteEducationInformation", params);
};

export const getEmployeeDurationOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "DURATION_WORK",
  });
};

export const getWorkIn = async (params = {}) => {
  return await api.post("/v1/timeAttendance/getWorkInPaging", params);
};

export const getWorkInDetail = async (params = {}) => {
  return await api.post("/v1/timeAttendance/getWorkInDetail", params);
};
export const txnTimeAttendanceEdit = async (params = {}) => {
  return await api.post("/v1/timeAttendance/txnTimeAttendanceEdit", params);
};

export const getEmployeeByCompanyId = async (params = {}) => {
  return await api.post("/v1/dropdown/getEmployee", params);
};

export const getEmployeSubOrdinates = async (params = {}) => {
  return await api.post("/v1/dropdown/getEmployeSubOrdinates", params);
}

export const getMovement = async (params = {}) => {
  return await api.post("/v1/movement/getMovement", params);
};


export const compressedImage = async (params = {}) => {
  return await apiFormData.post(
    "/v1/image/compressedImage",
    params,
    {
      responseType: 'blob'
    }
  );
};

export const exportExcelEmployee = async (params = {}) => {
  return await api.post("/v1/employee/exportExcelEmployee", params, {
    responseType: 'blob'
  });
};
export const uploadEmployeeGroupCalculation = async (params = {}) => {
  return await apiFormData.post("/v1/payment/uploadEmployeeGroupCalculation", params);
};

export const exportTxnPaymentByTxnPayrollPeriodIdXlsx = async (params = {}) => {
  return await api.post("/v1/payment/exportTxnPaymentByTxnPayrollPeriodIdXlsx", { ...params, timeout: 99999999 }, {
    responseType: 'blob'
  });
};

export const verifyEmployee = async (params = {}) => {
  return await apiFormData.post("/v1/employee/verifyEmployee", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const getBranch = async (params = {}) => {
  return await api.post("/v1/dropdown/getBranch", params);
};

export const exportExcelEmployeeFail = async (params = {}) => {
  return await api.post("/v1/employee/exportExcelEmployeeFail", params, { responseType: 'blob' });
};

export const getEmployeeWorkInCount = async (params = {}) => {
  return await api.post("/v1/employee/getEmployeeWorkInCountStatus", params);
};

export const manageBenefitStatus = async (params = {}) => {
  return await api.post("/v1/leaveBenefit/manageLeaveBenefitStatus", params);
};

export const getRemainingLeaveWithIn = async (params) => {
  return await api.post("/v1/timePlanShift/getRemainingLeaveWithIn", params);
};



export const calNewLeaveBenefit = async (params = {}) => {
  return await api.post("/v1/leaveBenefit/calNewLeaveBenefit", params);
};
export const calNewLeaveBenefitByLeaveType = async (params = {}) => {
  return await api.post("/v1/leaveBenefit/calNewLeaveBenefitByLeaveType", params);
};
export const calNewLeaveBenefitByLeaveTypeList = async (params = {}) => {
  return await api.post("/v1/leaveBenefit/calNewLeaveBenefitByLeaveTypeList", params);
};

export const ExportWorkingTimeGroupReportPagingeByEmp = async (params = {}) => {
  return await api.post("/v1/reportEmployee/exportEmployeeWorkingTime", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const getEmployeeYearAccumulateByEmpId = async (params = {}) => {
  return await api.post("/v1/employeeYearAccumulate/getEmployeeYearAccumulate", { ...params, timeout: 99999999 });
};
export const editTxnEmployeeYearAccumulate = async (params = {}) => {
  return await api.post("/v1/employeeYearAccumulate/editTxnEmployeeYearAccumulate", { ...params, timeout: 99999999 });
};

export const getCountNotification = async (params = {}) => {
  return await api.post("/v1/notification/getCount", params);
};

export const createSupervisorOtRequest = async (params) => {
  return await apiFormData.post("/v1/overtimeRequest/createOvertimeRequest", params);
};

export const getCompany = async (params = {}) => {
  return await api.post("/v1/company/getCompany", params);
};

export const getEmployeeWelfarePagination = async (params = {}) => {
  return await api.post("/v1/employee/getEmployeeWelfarePagination", params);
};

export const updateEmployeeWelfare = async (params = {}) => {
  return await api.post("/v1/welfare/updateEmployeeWelfare", params);
};

export const deleteEmployeeWelfare = async (params = {}) => {
  return await api.post("/v1/welfare/deleteCreditLimitByEmp", params);
};

export const manageEmployeeWelfareStatus = async (params = {}) => {
  return await api.post("/v1/welfare/manageEmployeeWelfareStatus", params);
}
export const getLeaveGroupIsOffSite = async (params = {}) => {
  return await api.post("/v1/dropdown/getLeaveCategoryGroupIsOffsite", params);
};

export const createOffsiteWorkRequest = async (params) => {
  return await apiFormData.post("/v1/offsiteWorkRequest/createOffsiteWorkRequest", params);
};

export const createLeaveRequest = async (params) => {
  return await apiFormData.post("/v1/leaveRequest/createLeaveRequest", params);
};

export const getEmployeeWorkingCountReport = async (params) => {
  return await api.post("/v1/employee/getEmployeeWorkingCountReport", params);
};

export const getEmployeeWorkingDetailReport = async (params) => {
  return await api.post("/v1/employee/getEmployeeWorkingDetailReport", params);
};

export const getSubOrdinateVisaWorkPermitInfo = async (params) => {
  return await api.post("/v1/employee/getSubOrdinateVisaWorkPermitInfo", params);
};
export const getCompanyVisaWorkPermitInfo = async (params) => {
  return await api.post("/v1/employee/getCompanyVisaWorkPermitInfo", params);
};

export const saveMemo = async (params = {}) => {
  return await api.post("/v1/memo/saveMemo", params);
};

export const getMemo = async (params = {}) => {
  return await api.post("/v1/memo/getMemo", params);
};
